'use strict';

/**
 * Pict-Provider-MessageAPI
 * ------------------------
 * Browser-side client for the org message templates (/1.0/Org/MessageTemplates).
 * Backs the Message Templates section of the settings hub. Gated server-side by
 * platform.manage.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'MessageAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderMessageAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	initializeAppData()
	{
		if (!this.fable.AppData.Messaging) { this.fable.AppData.Messaging = { Templates: [] }; }
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	getTemplates()
	{
		this.initializeAppData();
		return libFrameworkClient.getJSON(this.fable, this._url('Org/MessageTemplates'))
			.then((pBody) =>
			{
				this.fable.AppData.Messaging.Templates = Array.isArray(pBody.Templates) ? pBody.Templates : [];
				return this.fable.AppData.Messaging.Templates;
			})
			.catch(() =>
			{
				this.fable.AppData.Messaging.Templates = [];
				return this.fable.AppData.Messaging.Templates;
			});
	}

	saveTemplate(pKey, pPatch)
	{
		return libFrameworkClient.putJSON(this.fable, this._url('Org/MessageTemplates/' + encodeURIComponent(pKey)), pPatch || {})
			.then((pBody) =>
			{
				if (!pBody.Success) { throw new Error((pBody && pBody.Error) || 'Request failed.'); }
				return pBody;
			});
	}

	previewTemplate(pKey, pPatch)
	{
		return libFrameworkClient.postJSON(this.fable, this._url('Org/MessageTemplates/' + encodeURIComponent(pKey) + '/Preview'), pPatch || {});
	}

	testSend(pKey, pChannel, pTo)
	{
		return libFrameworkClient.postJSON(this.fable, this._url('Org/MessageTemplates/' + encodeURIComponent(pKey) + '/TestSend'), { Channel: pChannel, To: pTo })
			.then((pBody) =>
			{
				if (!pBody.Success) { throw new Error((pBody && pBody.Error) || 'Request failed.'); }
				return pBody;
			});
	}
}

module.exports = PictProviderMessageAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
